// import React from "react";
// import Posts from "../components/Posts";

// const Home = () => {
//   return <Posts />;
// };

// export default Home;

import React from "react";
import Posts from "../components/Posts";

const Home = () => {
  return (
    // <section className="home">
    //   <div className="center">
    //     <h2>Welcome to the Blog Platform</h2>
    //     <p>Discover and share your favorite posts with our community.</p>
    //   </div>
    // </section>
    <Posts />
  );
};

export default Home;
